import type { JSX, ReactNode } from "react";
import { glossaryHint } from "./glossary";

/**
 * A metric label with a hover/focus explanation (#228 manual-test feedback).
 * The explanation comes from an explicit `hint` or, by default, the glossary
 * keyed on the label text. With no hint the children render bare (no marker),
 * so it is safe to wrap any label. The affordance is a dotted underline (not a
 * decorative icon — design system), and the tip is keyboard-reachable.
 */
export function Term({ children, hint }: { children: ReactNode; hint?: string }): JSX.Element {
  const text = typeof children === "string" ? children : "";
  const tip = hint ?? glossaryHint(text);
  if (tip === undefined) return <>{children}</>;
  return (
    <span className="cc-term" tabIndex={0} aria-label={`${text}：${tip}`}>
      {children}
      <span className="cc-term-tip" role="tooltip">{tip}</span>
    </span>
  );
}

/** A card heading that auto-attaches a glossary tooltip when one is registered. */
export function CardTitle({ children }: { children: ReactNode }): JSX.Element {
  return <div className="cc-card-title"><Term>{children}</Term></div>;
}
